import { createService } from '../createService';

export const StandardService = createService({
  title: 'Стандарт',
  subTitle: 'Меньше звонков',
  description: ['Ниже Топа и Премиума', 'Не выделяется в поиске'],
  dataName: 'StandardService',
  bgColor: 'white',
  icon: null,
});
